import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import '../../pages/Capacitaciones.css';

function ModalPracticanteCarta({ isOpen, row, onClose, onSave }) {
  const [archivo, setArchivo] = useState(null);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const fileRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setArchivo(null);
    setFechaInicio('');
    setFechaFin('');
    if (fileRef.current) fileRef.current.value = '';
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!archivo) return alert('Seleccione un archivo PDF.');
    if (!fechaInicio) return alert('Indique la fecha de inicio de prácticas.');
    if (!fechaFin) return alert('Indique la fecha de fin de prácticas.');
    if (fechaFin < fechaInicio) return alert('La fecha de fin no puede ser anterior a la de inicio.');
    try {
      await onSave({
        id_requerimiento: row.id_requerimiento,
        carta: archivo,
        fecha_inicio_practica: fechaInicio,
        fecha_fin_practica: fechaFin,
      });
      onClose(true);
    } catch {
    }
  };

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>CARTA DE PRESENTACIÓN</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>Practicante</Label>
              <Input type="text" value={row?.nombre_practicante || ''} disabled />
            </FormGroup>
            <FormGroup>
              <Label>Fecha inicio prácticas</Label>
              <Input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label>Fecha fin prácticas</Label>
              <Input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label>Carta de presentación (PDF)</Label>
              <div className="cap-upload-zone">
                <span className="cap-upload-btn" onClick={() => fileRef.current?.click()}>
                  {archivo ? archivo.name : 'Seleccionar PDF'}
                </span>
                <input
                  ref={fileRef}
                  type="file"
                  accept=".pdf"
                  style={{ display: 'none' }}
                  onChange={(e) => setArchivo(e.target.files?.[0] || null)}
                />
              </div>
              <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>
                {archivo ? (
                  <span
                    style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                    onClick={() => {
                      setArchivo(null);
                      if (fileRef.current) fileRef.current.value = '';
                    }}
                  >
                    ✕ Quitar
                  </span>
                ) : (
                  'Ningún archivo'
                )}
              </div>
            </FormGroup>
            <div className="button-container" style={{ marginTop: 14 }}>
              <Button className="button-custom" color="secondary" onClick={() => onClose(false)}>
                CANCELAR
              </Button>
              <Button className="button-custom" onClick={handleSubmit}>
                GUARDAR
              </Button>
            </div>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalPracticanteCarta;
